import { render, staticRenderFns } from "./GuardSVG.vue?vue&type=template&id=0ce2b2f7&scoped=true&"
import script from "./GuardSVG.vue?vue&type=script&lang=js&"
export * from "./GuardSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce2b2f7",
  null
  
)

export default component.exports